import React from 'react';

import classes from './MapBackgroundLayer.module.css';

const mapBackgroundLayer = (props) => {
    
    let attachedClasses = [classes.MapBackgroundLayer];

    if (props.active){
        attachedClasses.push(classes.Active)
    }

    return(
        <li
            className={attachedClasses.join(' ')}
            onClick={props.clicked}
        >
            <img src={props.image} alt={props.label} />
            <span>{props.label}</span>
        </li>
    )
};

export default mapBackgroundLayer;